module.exports = __webpack_public_path__ + "static/media/csm-off-app-provider-icon.e6403875.svg";